export default __webpack_public_path__ + "static/media/gallery_01.853b89c6.jpg";